import { Box, Typography } from 'hephaestus/web';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Minimal empty state shown when no accounts are approaching threshold.
 * Per AC #5: a low-key one-liner — no success icon, minimal height.
 */
export const WatchListEmptyState: FC = () => {
  const { t } = useTranslation('watchList');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        py: 1,
      }}
    >
      <Typography
        variant='bodyMedium'
        sx={{ fontWeight: 500 }}
        color='textSecondary'
      >
        {t('empty.title')}
      </Typography>
    </Box>
  );
};
